import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import DropZone from "../../../commons/dropZone/DropZone";
import FormikTextField from "../../../commons/formik/FormikTextField";
import CharactersCounterLabel from "../../../commons/labels/CharactersCounterLabel";
import CircularLoading from "../../../commons/loading/CircularLoading";
import { StyledSiniestralidad } from "../../../styled/Siniestros";

const validationSchema = Yup.object().shape({
  observaciones: Yup.string()
    .max(5000, "El campo no puede superar los 5000 caracteres")
    .required("Campo obligatorio"),
});

const SiniestroAgregarDocumentacionForm = ({
  open,
  handleClose,
  handleSubmit,
  siniestro,
  file,
  setFile,
  isAgregarDocumentacion,
}) => {

  const isCargandoFI = useSelector(
    (state) => state.siniestralidad.cargarFi.loading
  );

  const initialValues = {
    siniestroArt: siniestro.siniestroART,
    tipoSiniestro: siniestro.tipoSiniestro,
    nroDocumento: siniestro.nroDocumento,
    apellidoNombre: siniestro.apellidoNombre,
    fechaHoraEvento: new Date(),
    observaciones: "",
    idSiniestroCabecera: siniestro.idSiniestroCabecera,
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
      <DialogTitle>Ingresar Documentación</DialogTitle>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit({ ...values, file })}
      >
        {({ values }) => (
          <Form>
            {isCargandoFI ? (
              <StyledSiniestralidad.FormLoading>
                <CircularLoading />
              </StyledSiniestralidad.FormLoading>
            ) : (
              <StyledSiniestralidad.FormContent>
                <StyledSiniestralidad.FormRow>
                  <FormikTextField
                    fullWidth={true}
                    name="siniestroArt"
                    label="Nro Siniestro"
                    type="text"
                    disabled
                  />
                  <FormikTextField
                    fullWidth={true}
                    name="tipoSiniestro"
                    label="Tipo Siniestro"
                    type="text"
                    disabled
                  />
                </StyledSiniestralidad.FormRow>
                <StyledSiniestralidad.FormRow>
                  <FormikTextField
                    fullWidth={true}
                    name="nroDocumento"
                    label="Número Documento"
                    type="text"
                    disabled
                  />
                  <FormikTextField
                    fullWidth={true}
                    name="apellidoNombre"
                    label="Apellido y Nombre"
                    type="text"
                    disabled
                  />
                </StyledSiniestralidad.FormRow>
                <StyledSiniestralidad.FormObservaciones>
                  <FormikTextField
                    fullWidth={true}
                    name="observaciones"
                    label="Observaciones"
                    type="text"
                    variant="outlined"
                    multiline
                    maxRows={15}
                    minRows={2}
                  />
                  <CharactersCounterLabel
                    value={values.observaciones}
                    maxCharacters={isAgregarDocumentacion ? 5000 : 8000}
                  />
                </StyledSiniestralidad.FormObservaciones>
                <DropZone
                  file={file}
                  setFile={setFile}
                  loading={false}
                  maxFiles={5}
                  extension=".TXT, .PDF, .JPG, .PNG, .XLS o .DOCX."
                  accept={{
                    "application/vnd.ms-excel": [".xls"],
                    "text/plain": [".txt"],
                    "application/pdf": [".pdf"],
                    "image/jpeg": [".jpg"],
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                      [".docx"],
                    "image/png": [".png"],
                  }}
                  dropZoneText="Arrastre aquí o haga click en el recuadro para importar información en formato TXT, PDF, JPG, PNG, XLS, DOCX."
                  dropZoneEditText="Si desea subir mas archivos arrastrelos nuevamente o haga click en el recuadro."
                />
              </StyledSiniestralidad.FormContent>
            )}
            <StyledSiniestralidad.FormButtonsContainer>
              <Button variant="outlined" onClick={handleClose}>
                Cancelar
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Enviar
              </Button>
            </StyledSiniestralidad.FormButtonsContainer>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default SiniestroAgregarDocumentacionForm;
